import { MLM, NOT_SET } from '@sunrise/tracking'
import { TrackingParameter } from '@sunrise/tracking'

import { EstateType } from '../../ts/mapper/decoratedEstateDetailMapper.enum'
import { OfferType } from '../../ts/service/realEstateService.enum'
import { ActionIds, MLMData } from '../../ts/tracking/mlmActionIds.enum'
import { staticMlmTrackingData } from '../../ts/tracking/mlmStaticTrackingData'
import { TealiumTrackingIds } from '../../ts/tracking/tealiumTrackingIds.enum'
import { CompanyName, TypePaid } from '../../ts/utils/trackingUtils.enum'

export function buildMlmTrackingData(
    componentId: string,
    exposeeId: number | null,
    currentUrl?: string,
): MLM.TrackingData {
    return {
        ...staticMlmTrackingData,
        page: MLMData.DEFAULT_PAGE as number,
        actionId: ActionIds.SUBMIT_CONTACT_FORM,
        componentId,
        pageUrl: currentUrl || '',
        items: [buildMlmItems(exposeeId)],
    }
}

function buildMlmItems(exposeeId: number | null): MLM.Item {
    return {
        id: exposeeId?.toString() || '-1',
        type: CompanyName.OWN_INVENTORY,
        typePaid: TypePaid.OWN_INVENTORY,
        typePosition: 1,
    }
}

export function buildTealiumTrackingData(
    exposeeId: number | null,
    currentSteps: number,
    numberOfSteps: number,
    offerType: OfferType,
    estateType: EstateType,
): TrackingParameter {
    return {
        mslayer_element_body_type: 'overlay',
        mslayer_element_company_name: NOT_SET,
        mslayer_element_count: NOT_SET,
        mslayer_element_data_id: TealiumTrackingIds.DETAIL_ACTIONS,
        mslayer_element_detail_start_date: NOT_SET,
        mslayer_element_id: exposeeId?.toString() || -1,
        mslayer_element_position: NOT_SET,
        mslayer_element_text: 'immobilien_expose',
        mslayer_element_type_text: 'kontaktieren_email_send',
        mslayer_element_variant: calculateProgress(currentSteps, numberOfSteps).toString(),
        mslayer_element_ad_type: `${offerType?.toLowerCase()}_${estateType?.toLowerCase()}`,
    }
}

const calculateProgress = (currentSteps: number, numberOfSteps: number) => (currentSteps / numberOfSteps) * 100
